import type { Observable } from 'rxjs';
import { isRemoveSubscriptionUpdate } from '../../pipes/utils';
import type { WSSubscriptionMemoryOutput } from '../../pipes/wsSubscriptionMemory';
import type { Security } from '../../types/Security';
import type { MinimalSubscriptionResponse } from '../../types/SubscriptionResponse';

export type SecurityMemoryObservable = Observable<WSSubscriptionMemoryOutput<Security>>;

export const getCurrencyPairFromSecurity = (security: Security) => `${security.BaseCurrency}-${security.QuoteCurrency}`;

/**
 * Deleted securities can arrive without Symbol in Whitelabel, violating the Security contract.
 * Reject them before they are distributed through shared security memory or derived indexes.
 */
export function isValidSecurity(security: Security) {
  return security.Symbol != null;
}

/** Active indexes exclude expired securities and soft-deleted securities. */
export function isActiveSecurity(security: Security) {
  const now = Date.now();
  if (security.Expiration != null && Date.parse(security.Expiration) < now) {
    return false;
  }
  if (security.EndTime != null && Date.parse(security.EndTime) < now) {
    return false;
  }
  return true;
}

export function shouldDeleteSecurityFromIndex(security: Security, message?: MinimalSubscriptionResponse<Security>) {
  // Product-specific indexes decide what can enter the map with `isRelevant`.
  // Once a security is in one of those maps, the only normal ways it should leave
  // are a websocket remove or becoming inactive through Expiration/EndTime.
  return isRemoveSubscriptionUpdate(security, message) || !isActiveSecurity(security);
}
